"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMainPageRoutes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const device_1 = require("@completeanatomy/device");
const infobox_1 = require("@completeanatomy/infobox");
const odr_1 = require("@completeanatomy/odr");
const tools_1 = require("@completeanatomy/tools");
const ui_1 = require("@completeanatomy/ui");
const user_onboarding_1 = require("@completeanatomy/user-onboarding");
const FakeNeoIdScreen_1 = require("../pages/FakeNeoIdScreen");
const UnsupportedWebScreen_1 = __importDefault(require("../pages/UnsupportedWebScreen/UnsupportedWebScreen"));
const providers_1 = require("../providers");
const MainScreenStateProvider_1 = require("../providers/MainScreenStateProvider");
const StackRouter_1 = __importDefault(require("../organisms/StackRouter"));
const pages_1 = require("../pages");
function MainPageWrapper() {
    (0, user_onboarding_1.useOnboardingLicense)();
    const shouldAnimate = (pathname) => {
        return (!pathname.includes('mode') &&
            !pathname.includes('tutorial') &&
            !pathname.includes('tips'));
    };
    return ((0, jsx_runtime_1.jsx)(ui_1.ModalProvider, { children: (0, jsx_runtime_1.jsx)(device_1.PlatformProvider, { children: (0, jsx_runtime_1.jsx)(ui_1.SnackbarProvider, { children: (0, jsx_runtime_1.jsx)(infobox_1.InfoBoxStateProvider, { children: (0, jsx_runtime_1.jsx)(tools_1.ToolsStateProvider, { children: (0, jsx_runtime_1.jsx)(tools_1.ToolsServiceProvider, { children: (0, jsx_runtime_1.jsx)(ui_1.ThemeProvider, { children: (0, jsx_runtime_1.jsx)(MainScreenStateProvider_1.MainScreenProvider, { children: (0, jsx_runtime_1.jsx)(providers_1.SearchProvider, { children: (0, jsx_runtime_1.jsx)(StackRouter_1.default, { shouldAnimate: shouldAnimate, basePath: "/" }) }) }) }) }) }) }) }) }) }));
}
function createMainPageRoutes(basePath = '/') {
    return {
        path: basePath,
        element: (0, jsx_runtime_1.jsx)(MainPageWrapper, {}),
        children: [
            {
                path: '/',
                element: (0, jsx_runtime_1.jsx)(pages_1.MainScreen, { webSdkId: "model-container" }),
                children: [],
            },
            ...user_onboarding_1.userOnboardingRoutes,
            {
                path: '/sign-in',
                element: (0, jsx_runtime_1.jsx)(FakeNeoIdScreen_1.FakeNeoIdScreen, {}),
                children: [],
            },
            {
                path: '/error',
                element: (0, jsx_runtime_1.jsx)(odr_1.ModelDownloadingErrorGrasshopper, {}),
                children: [],
            },
            {
                path: '/invalidScreenError',
                element: (0, jsx_runtime_1.jsx)(UnsupportedWebScreen_1.default, {}),
                children: [],
            },
        ],
    };
}
exports.createMainPageRoutes = createMainPageRoutes;
